export const LTR_ATTR_SELECTOR = '[dir="ltr"]';
export const RTL_ATTR_SELECTOR = '[dir="rtl"]';
